import { useEffect, useState, useRef, useCallback } from "react";

export const useCountdown = (duration: number, shouldReset: boolean) => {
  const [countdown, setCountdown] = useState(duration);
  const intervalRef = useRef<typeof setInterval>(null);

  const resetTimer = useCallback(() => {
    setCountdown(duration);
  }, [duration]);

  const clearTimer = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    intervalRef.current = null;
    setCountdown(0);
  }, []);

  const getReturnValues = (countDown: number) => {
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

    return {
      isExpired: countDown < 1,
      timer: [minutes, seconds],
    };
  };

  useEffect(() => {
    const startTimer = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      intervalRef.current = window.setInterval(() => {
        setCountdown(prevCountdown => prevCountdown - 1000);
      }, 1000);
    };

    const stopTimer = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      clearInterval(intervalRef.current);
    };

    if (shouldReset) {
      resetTimer();
    } else {
      startTimer();
    }

    return () => {
      stopTimer();
    };
  }, [duration, resetTimer, shouldReset]);

  useEffect(() => {
    if (countdown <= 0) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      clearInterval(intervalRef.current);
    }
  }, [countdown]);

  return { ...getReturnValues(countdown), resetTimer, clearTimer };
};
